import Http from '@/api/http.js'

export default {
  show(id) {
    return Http.get(`/payed_shippings/${id}.pdf`, { responseType: 'blob' });
  },
}
